import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { Button, Grid, Group, Image, Stack, Text } from '@mantine/core';
import { getSharepointCdnFile } from '../../../utilities';
import NoImage from '../../../assets/icon/illustrations_no-document.svg';
import ButtonBeelajar from '../../elements/Button';
import { useDisclosure } from '@mantine/hooks';
import { useMutation } from '@tanstack/react-query';
import { addPoint } from '../../../services/homepage';
import ModalSearchComponentsWisdomDetail from './ModalSearchComponentsWisdom';
import ModalDetailPersonalWisdom from '../PersonalWisdomSection/ModalDetailPersonalWisdom';
import { highlightText } from '../../../utilities/highlightText';
import {store} from "../../../store/AppStore";

const SearchComponentsWisdom: React.FC<any> = ({ data, querysearch }) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [isHovered, setIsHovered] = useState(false);
  const ref = useRef(null);
  const [dataPilihan, setDataPilihan] = useState<any>([]);

  const handleMouseOver = () => setIsHovered(true);
  const handleMouseOut = () => setIsHovered(false);

  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener('mouseover', handleMouseOver);
      node.addEventListener('mouseout', handleMouseOut);

      return () => {
        node.removeEventListener('mouseover', handleMouseOver);
        node.removeEventListener('mouseout', handleMouseOut);
      };
    }
  }, []);

  const checkIsUserLoggedIn = () => {
    const reduxState: any = store.getState();
    return !!reduxState.auth?.userData?.binusianId;
  }

  const completedMission = useMutation({
    mutationFn: addPoint
  });

  const handleAddPoint = (data) => {
    let payload = {
      idLearningPage: data,
      from: 'Testimony'
    };
    completedMission.mutate(payload);
  };

  const handleDataPilihan = (dapil) => {
    // console.log(dapil);
    setDataPilihan(dapil);
    open();
  };

  useEffect(() => {
    // console.log(dataPilihan);
  }, [dataPilihan]);

  return (
    <>
      <Grid>
        {data.map((item, index) => (
          <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
            <div
              className="container-testimony-item"
              onClick={() => {
                if(checkIsUserLoggedIn()) {
                  handleAddPoint(item.id);
                }
                handleDataPilihan(item);
              }}
              style={{
                ...(() => {
                  if (item.isCarousel) return { transform: 'none' };
                })()
              }}
              ref={ref}
            >
              <Stack gap={10} justify="space-between" h={'100%'}>
                <div>
                  <Text fz={16} fw={700}>
                    {querysearch
                      ? highlightText(item.title, querysearch)
                      : item.title}
                  </Text>

                  <Text fz={14} fw={500} mt={10}>
                    {item.shortDescription.length > 100
                      ? querysearch
                        ? highlightText(
                            item.shortDescription.substring(0, 100) + '...',
                            querysearch
                          )
                        : item.shortDescription.substring(0, 100) + '...'
                      : querysearch
                      ? highlightText(item.shortDescription, querysearch)
                      : item.shortDescription}
                  </Text>
                </div>

                <Group gap={10}>
                  <div className="container-testimony-item__image-cover">
                    <Image
                      src={
                        item.imageFilePath
                          ? getSharepointCdnFile(item.imageFilePath)
                          : NoImage
                      }
                      className="container-testimony-item__image"
                    />
                  </div>

                  <Stack gap={0}>
                    <Text fz={12} fw={700}>
                      {item.name}
                    </Text>
                    <Text fz={10} fw={500} c={'gray'}>
                      {item.position === null
                        ? '-'
                        : item.position?.length > 0
                        ? item.position.substring(0, 20) + '...'
                        : item.position}
                    </Text>
                    <Text fz={10} fw={500} c={'gray'}>
                      {item.unit?.length > 0
                        ? item.unit.substring(0, 20) + '...'
                        : item.unit}
                    </Text>
                  </Stack>
                </Group>
              </Stack>
            </div>
          </Grid.Col>
        ))}
      </Grid>
      <ModalDetailPersonalWisdom
        isVisible={opened}
        content={dataPilihan?.shortDescription}
        name={dataPilihan?.name}
        onClose={() => close()}
        photo={
          dataPilihan?.imageFilePath
            ? getSharepointCdnFile(dataPilihan?.imageFilePath)
            : NoImage
        }
        position={dataPilihan?.position}
        title={'Personal Wisdom'}
        unit={dataPilihan?.unit}
        key={dataPilihan?.id}
      />
    </>
  );
};

export default SearchComponentsWisdom;
